<template>
  <select v-model="selected">
    <option disabled :value="null">Please select one</option>
    <option
      v-for="student of students"
      :key="student.id"
      :value="student"
    >
      {{ student.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { Group, Student } from '@/store/groups/types'
import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator'

@Component
export default class SelectPositionInput extends Vue {
  @Prop({ required: true }) groupId!: string

  @Prop() value?: Student

  private get selected(): Student|null {
    return this.value || null
  }

  private set selected(position: Student|null) {
    this.$emit('input', position)
  }

  private get students(): Student[] {
    const group: Group = this.$store.getters.findGroupById(this.groupId)
    return group?.students || []
  }

  @Watch('groupId')
  changedGroup(groupId: string) {
    this.$store.dispatch('getGroupById', { groupId })
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
